// Colunas do grid.
export const Columns = [
	{
		headerName: 'name',
		field: 'name',
		filter: true
	},
	{
		headerName: 'cnpj',
		field: 'document',
		filter: true,
		type: 'cnpj'
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans',
		with: 130
	}
]